@if (showMenu()) {
    <div class="menu">
        @if (currentState() === FavoriteListStates.Overview) {
            <div class="menu-item" (click)="onOpen.emit(selectedId()); $event.stopPropagation()">Åpne</div>
        }
        <div class="menu-item" (click)="onRename.emit(selectedId()); $event.stopPropagation()">Endre tittel på liste</div>
        <div class="separator"></div>
        <div class="menu-item" [class.disabled]="!canExport()" (click)="exportSelectionToExcel($event)">Eksporter liste til Excel</div>
        <div class="menu-item" [class.disabled]="!canExport()" (click)="exportSelectionToPdf($event)">Eksporter liste til PDF</div>
        <div class="separator"></div>
        <div class="menu-item" [class.disabled]="!hasAreaFilter() && !hasUnitFilter()" (click)="zoomToArea($event)">Zoom til område</div>
        @if (currentState() === FavoriteListStates.Details && hasUnitFilter()) {
            <div class="menu-item alert" (click)="onRemoveAllSelection.emit(selectedId()); $event.stopPropagation()">Fjern alle enkelteiendommer</div>
        }
        @if (currentState() === FavoriteListStates.Details && !hasUnitFilter()) {
            <div class="menu-item" (click)="onAddAllSelection.emit(selectedId()); $event.stopPropagation()">Legg til alle fra utvalg</div>
        }
        <div class="separator"></div>
        @if (currentState() === FavoriteListStates.Details) {
            <div class="menu-item" (click)="onClose.emit(selectedId()); $event.stopPropagation()">Lukk liste</div>
        }
        <div class="menu-item alert" (click)="onDelete.emit(selectedId()); $event.stopPropagation()">Slett liste</div>
    </div>
}
